<div class="w-full max-w-full relative space-y-6 px-4">
    <!-- Header Section -->
    <div class="py-2 px-1">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
                <h1 class="text-xl font-bold text-[#141437] dark:text-white">
                    Headline Management
                </h1>
                <p class="text-sm text-slate-500 dark:text-slate-400">
                    Manage your headline pages and API endpoints efficiently.
                </p>
            </div>
            <div class="flex items-center gap-3">
                @if (activeTab() === 'agent') {
                <app-button variant="primary" [iconName]="'plus'" (buttonClick)="openAgentAddPanel()"
                    className="flex items-center justify-center gap-2 shadow-[0px_6px_12px_-6px_#AD46FF] hover:shadow-[0px_4px_8px_-4px_#AD46FF] transition-all bg-[#AD46FF] hover:bg-[#AD46FF] border-none text-white px-6 h-11">
                    <span class="font-medium whitespace-nowrap">Add Agent</span>
                </app-button>
                } @else if (activeTab() === 'auth') {
                <app-button variant="primary" [iconName]="'plus'" (buttonClick)="openAuthAddPanel()"
                    className="flex items-center justify-center gap-2 shadow-[0px_6px_12px_-6px_#AD46FF] hover:shadow-[0px_4px_8px_-4px_#AD46FF] transition-all bg-[#AD46FF] hover:bg-[#AD46FF] border-none text-white px-6 h-11">
                    <span class="font-medium whitespace-nowrap">Add Auth Config</span>
                </app-button>
                } @else {
                <app-button variant="primary" [iconName]="'plus'" (buttonClick)="openAddPanel()"
                    className="flex items-center justify-center gap-2 shadow-[0px_6px_12px_-6px_#AD46FF] hover:shadow-[0px_4px_8px_-4px_#AD46FF] transition-all bg-[#AD46FF] hover:bg-[#AD46FF] border-none text-white px-6 h-11">
                    <span class="font-medium whitespace-nowrap">{{ activeTab() === 'headline' ? 'Create Page' : 'Add
                        API' }}</span>
                </app-button>
                }
            </div>
        </div>
    </div>

    <!-- Main Content Card -->
    <div
        class="bg-white dark:bg-surface-1 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden flex flex-col">
        <!-- Tabs Navigation -->
        <div
            class="flex border-b border-slate-100 dark:border-slate-800/60 bg-slate-50/20 dark:bg-slate-900/10 overflow-x-auto no-scrollbar">
            <button (click)="switchTab('headline')"
                class="flex items-center gap-2 px-4 sm:px-8 py-5 text-sm font-bold transition-all duration-200 relative outline-none whitespace-nowrap"
                [ngClass]="activeTab() === 'headline' ? 'text-purple-600 dark:text-purple-400 border-b-2 border-purple-600 dark:border-purple-400' : 'text-slate-500 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300 border-b-2 border-transparent'">
                <app-icon name="fileText" [size]="18" />
                Headline Pages
                <span class="ml-1 px-2.5 py-0.5 text-[10px] font-bold rounded-full transition-colors duration-200"
                    [ngClass]="activeTab() === 'headline' ? 'bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400' : 'bg-slate-100 dark:bg-slate-800 text-slate-500'">{{
                    headlineData().length }}</span>
            </button>
            <button (click)="switchTab('auth')"
                class="flex items-center gap-2 px-4 sm:px-8 py-5 text-sm font-bold transition-all duration-200 relative outline-none whitespace-nowrap"
                [ngClass]="activeTab() === 'auth' ? 'text-purple-600 dark:text-purple-400 border-b-2 border-purple-600 dark:border-purple-400' : 'text-slate-500 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300 border-b-2 border-transparent'">
                <app-icon name="shield" [size]="18" />
                Authentication
                <span class="ml-1 px-2.5 py-0.5 text-[10px] font-bold rounded-full transition-colors duration-200"
                    [ngClass]="activeTab() === 'auth' ? 'bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400' : 'bg-slate-100 dark:bg-slate-800 text-slate-500'">{{
                    authData().length }}</span>
            </button>
            <button (click)="switchTab('api')"
                class="flex items-center gap-2 px-4 sm:px-8 py-5 text-sm font-bold transition-all duration-200 relative outline-none whitespace-nowrap"
                [ngClass]="activeTab() === 'api' ? 'text-purple-600 dark:text-purple-400 border-b-2 border-purple-600 dark:border-purple-400' : 'text-slate-500 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300 border-b-2 border-transparent'">
                <app-icon name="squareTerminal" [size]="18" />
                API Management
                <span class="ml-1 px-2.5 py-0.5 text-[10px] font-bold rounded-full transition-colors duration-200"
                    [ngClass]="activeTab() === 'api' ? 'bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400' : 'bg-slate-100 dark:bg-slate-800 text-slate-500'">{{
                    apiData().length }}</span>
            </button>
            <button (click)="switchTab('agent')"
                class="flex items-center gap-2 px-4 sm:px-8 py-5 text-sm font-bold transition-all duration-200 relative outline-none whitespace-nowrap"
                [ngClass]="activeTab() === 'agent' ? 'text-purple-600 dark:text-purple-400 border-b-2 border-purple-600 dark:border-purple-400' : 'text-slate-500 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300 border-b-2 border-transparent'">
                <app-icon name="users" [size]="18" />
                Chatbot Agent Management
            </button>
        </div>

        <!-- Toolbar & Filters Section -->
        @if (activeTab() !== 'agent') {
        <div class="p-4 sm:p-8 space-y-6 sm:space-y-8">
            <div class="grid grid-cols-1 md:grid-cols-12 gap-6 items-end">
                <!-- Search -->
                <div class="md:col-span-12 lg:col-span-4">
                    <label
                        class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2 ml-1">Search</label>
                    <div class="relative">
                        <span class="absolute inset-y-0 left-4 flex items-center text-slate-400">
                            <app-icon name="search" [size]="18"></app-icon>
                        </span>
                        <input type="text" [value]="searchQuery()" (input)="searchQuery.set($any($event.target).value)"
                            [placeholder]="activeTab() === 'headline' ? 'Search' : (activeTab() === 'auth' ? 'Search' : 'Search')"
                            class="w-full pl-12 pr-4 h-11 bg-slate-50 dark:bg-surface-0 border border-slate-200 dark:border-slate-800 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-purple-500/20 transition-all placeholder:text-slate-400 dark:placeholder:text-slate-600">
                    </div>
                </div>

                <!-- Filters -->
                <div class="md:col-span-12 lg:col-span-4">
                    @if (activeTab() === 'headline' || activeTab() === 'auth') {
                    <div class="grid grid-cols-2 gap-4">
                        <div class="w-full">
                            <label
                                class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2 ml-1">Product</label>
                            <app-dropdown [options]="productDropdownOptions()" [selectedValue]="selectedProduct()"
                                (selectionChange)="selectedProduct.set($event)" placeholder="All Products"
                                [fullWidth]="true" variant="themeBase" [searchable]="false" />
                        </div>
                        <div class="w-full">
                            <label
                                class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2 ml-1">Status</label>
                            <app-dropdown [options]="statusOptions" [selectedValue]="selectedStatus()"
                                (selectionChange)="selectedStatus.set($event)" placeholder="All Status"
                                [fullWidth]="true" variant="themeBase" [searchable]="false" />
                        </div>
                    </div>
                    } @else if (activeTab() === 'api') {
                    <div class="grid grid-cols-3 gap-4">
                        <div class="w-full">
                            <label
                                class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2 ml-1">Product</label>
                            <app-dropdown [options]="productDropdownOptions()" [selectedValue]="selectedProduct()"
                                (selectionChange)="selectedProduct.set($event)" placeholder="All Products"
                                [fullWidth]="true" variant="themeBase" [searchable]="false" />
                        </div>
                        <div class="w-full">
                            <label
                                class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2 ml-1">Page</label>
                            <app-dropdown [options]="pageFilterOptions()" [selectedValue]="selectedPage()"
                                (selectionChange)="selectedPage.set($event)" placeholder="All Pages"
                                [fullWidth]="true" variant="themeBase" [searchable]="true" />
                        </div>
                        <div class="w-full">
                            <label
                                class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2 ml-1">Status</label>
                            <app-dropdown [options]="statusOptions" [selectedValue]="selectedStatus()"
                                (selectionChange)="selectedStatus.set($event)" placeholder="All Status"
                                [fullWidth]="true" variant="themeBase" [searchable]="false" />
                        </div>
                    </div>
                    }
                </div>

                <!-- Actions -->
                <div class="md:col-span-12 lg:col-span-4 flex flex-col sm:flex-row items-center gap-3">
                    <app-button (buttonClick)="applyFilters()" variant="primary"
                        className="w-full sm:w-auto flex-1 h-11 bg-gradient-to-r from-[#AD46FF] to-[#8E2DE2] hover:opacity-90 text-white rounded-xl shadow-[0px_6px_15px_-4px_rgba(173,70,255,0.4)] transition-all font-bold tracking-wide px-6">
                        Apply Filters
                    </app-button>
                    <app-button (buttonClick)="resetFilters()" variant="ghost"
                        className="w-full sm:w-auto flex-1 h-11 text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 transition-colors font-semibold whitespace-nowrap bg-transparent min-w-max px-4">
                        Clear Filters
                    </app-button>
                </div>
            </div>
        </div>
        }

        <div class="p-4 sm:p-8 space-y-6 sm:space-y-8">
            <!-- Table Section -->
            <div
                class="rounded-2xl border border-slate-100 dark:border-slate-800/60 overflow-hidden shadow-sm min-h-[400px]">
                @if (activeTab() === 'headline') {
                <app-paginated-table [tableData]="filteredHeadlineData()" [headers]="headlineHeaders"
                    [tableActionOptions]="headlineActionOptions" (actionSelected)="handleTableAction($event)"
                    [isCheckboxShow]="false" [pageSize]="10" tableWrapperClass="bg-white dark:bg-surface-1" />
                } @else if (activeTab() === 'auth') {
                <app-paginated-table [tableData]="filteredAuthData()" [headers]="authHeaders"
                    [tableActionOptions]="authActionOptions" (actionSelected)="handleTableAction($event)"
                    [isCheckboxShow]="false" [pageSize]="10" tableWrapperClass="bg-white dark:bg-surface-1" />
                } @else if (activeTab() === 'api') {
                <app-paginated-table [tableData]="filteredApiData()" [headers]="apiHeaders"
                    [tableActionOptions]="apiActionOptions" (actionSelected)="handleTableAction($event)"
                    [isCheckboxShow]="false" [pageSize]="10" tableWrapperClass="bg-white dark:bg-surface-1" />
                } @else {
                <app-paginated-table [tableData]="processedAgentData()" [headers]="agentHeaders"
                    [tableActionOptions]="agentActionOptions" (actionSelected)="handleTableAction($event)"
                    [isCheckboxShow]="false" [pageSize]="10" tableWrapperClass="bg-white dark:bg-surface-1" />
                }
            </div>
        </div>
    </div>

    <!-- Slide Panel: Add API/Page -->
    <app-slide-panel [open]="panelOpen()"
        [title]="(isEditMode() ? 'Edit ' : (activeTab() === 'headline' ? 'Create ' : 'Add ')) + (activeTab() === 'headline' ? 'Page' : 'API')"
        (closed)="closePanel()"
        panelClass="w-full sm:min-w-[500px] lg:min-w-[600px] max-w-[700px] h-full flex flex-col overflow-hidden card-bg border-l border-[#EAEAEA] dark:border-line">
        <form [formGroup]="apiForm" (ngSubmit)="save()" class="flex flex-col flex-1 overflow-hidden h-full">
            <section class="flex flex-col gap-8 flex-1 overflow-y-auto p-10 text-[#141437] dark:text-white">
                <!-- Name -->

                <!-- Product Selection for Headline Page -->
                @if (activeTab() === 'headline') {
                <div class="space-y-3">
                    <label class="text-sm font-bold text-[#141437] dark:text-slate-200 block ml-1">Product</label>
                    <app-dropdown [options]="productDropdownOptions()" formControlName="product_id"
                        placeholder="Select product" variant="themeBase" [fullWidth]="true" />
                </div>
                }

                @if (activeTab() === 'api') {
                <!-- Headline Page Selection for API -->
                <div class="space-y-3">
                    <label class="text-sm font-bold text-[#141437] dark:text-slate-200 block ml-1">Headline Page</label>
                    <app-dropdown [options]="headlineDropdownOptions()" formControlName="headline_page_id"
                        placeholder="Select headline page" variant="themeBase" [fullWidth]="true" />
                </div>

                <!-- Data Source Selection for API -->
                <div class="space-y-3">
                    <label class="text-sm font-bold text-[#141437] dark:text-slate-200 block ml-1">Data Source</label>
                    <app-dropdown [options]="authDropdownOptions()" formControlName="data_source_id"
                        placeholder="Select data source" variant="themeBase" [fullWidth]="true" />
                </div>
                }

                <!-- Name -->
                <div class="space-y-3">
                    <label class="text-sm font-bold text-[#141437] dark:text-slate-200 block ml-1">
                        {{ activeTab() === 'headline' ? 'Name' : 'API Name' }}
                    </label>
                    <app-input formControlName="name"
                        [placeholder]="activeTab() === 'headline' ? 'Enter name' : 'Enter API name'"
                        variant="themeBase"></app-input>
                </div>

                <!-- Keyname -->
                <div class="space-y-3">
                    <label class="text-sm font-bold text-[#141437] dark:text-slate-200 block ml-1">
                        {{ activeTab() === 'headline' ? 'Keyname' : 'API Keyname' }}
                    </label>
                    <app-input formControlName="keyname"
                        [placeholder]="activeTab() === 'headline' ? 'Enter keyname' : 'Enter API keyname'"
                        variant="themeBase"></app-input>
                </div>

                <!-- Conditional Fields for API -->
                @if (activeTab() === 'api') {
                <!-- Method -->
                <div class="space-y-3">
                    <label class="text-sm font-bold text-[#141437] dark:text-slate-200 block ml-1">Method</label>
                    <app-dropdown [options]="addMethodOptions" formControlName="method" variant="themeBase"
                        [fullWidth]="true" [searchable]="false" />
                </div>

                <!-- Endpoint -->
                <div class="space-y-3">
                    <label class="text-sm font-bold text-[#141437] dark:text-slate-200 block ml-1">Endpoint</label>
                    <app-input formControlName="endpoint" placeholder="Enter endpoint" variant="themeBase"></app-input>
                </div>



                <!-- Payload Section -->
                <div class="space-y-4 pt-4">
                    <div class="flex items-center justify-between ml-1">
                        <label class="text-sm font-bold text-[#141437] dark:text-slate-200">Payload</label>
                        <button type="button" (click)="addPayloadField()"
                            class="text-xs font-bold text-[#AD46FF] hover:text-[#9124e2] transition-colors flex items-center gap-1.5 px-2 py-1 rounded-lg hover:bg-purple-50 dark:hover:bg-white/10">
                            <app-icon name="plus" [size]="14" />
                            Add Field
                        </button>
                    </div>

                    <div formArrayName="payload" class="space-y-3">
                        @for (item of payloadArray.controls; track item; let i = $index) {
                        <div [formGroupName]="i"
                            class="flex gap-3 group animate-in fade-in slide-in-from-top-2 duration-200">
                            <div class="flex-1">
                                <app-input formControlName="key" placeholder="Key" variant="themeBase"></app-input>
                            </div>
                            <div class="flex-1">
                                <app-input formControlName="value" placeholder="Value" variant="themeBase"></app-input>
                            </div>
                            <button type="button" (click)="removePayloadField(i)"
                                class="mt-2.5 h-11 w-11 flex items-center justify-center rounded-xl text-slate-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-all opacity-0 group-hover:opacity-100">
                                <app-icon name="trash" [size]="18" />
                            </button>
                        </div>
                        }
                    </div>
                </div>
                }

                <!-- Description (Shared for Page and API) -->
                @if (activeTab() === 'headline' || activeTab() === 'api') {
                <div class="space-y-3">
                    <label class="text-sm font-bold text-[#141437] dark:text-slate-200 block ml-1">Description</label>
                    <textarea formControlName="description" placeholder="Enter description..." rows="4"
                        class="w-full px-4 py-3 bg-[#F9FAFB] dark:bg-surface-0 border border-slate-200 dark:border-slate-800 rounded-xl text-sm text-slate-900 dark:text-white placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-purple-500/20 resize-none transition-all"></textarea>
                </div>
                }
            </section>

            <!-- Footer Action -->
            <div
                class="p-8 sticky bottom-0 bg-white dark:bg-surface-1 border-t border-[#EAEAEA] dark:border-line mt-auto">
                <div class="flex items-center justify-end gap-3">
                    <app-button variant="outline" (buttonClick)="closePanel()"
                        className="px-8 border-slate-200 text-slate-600 font-semibold h-11">Cancel</app-button>
                    <app-button type="submit" variant="primary"
                        className="px-12 bg-gradient-to-r from-[#AD46FF] to-[#8E2DE2] border-none hover:opacity-90 text-white font-bold h-11 shadow-[0px_6px_15px_-4px_rgba(173,70,255,0.4)]"
                        [disabled]="apiForm.invalid">
                        {{ isEditMode() ? 'Update' : (activeTab() === 'headline' ? 'Save' : 'Save API') }}
                    </app-button>
                </div>
            </div>
        </form>
    </app-slide-panel>

    <!-- Slide Panel: Authentication CRUD -->
    <app-slide-panel [open]="authPanelOpen()" [title]="(authIsEditMode() ? 'Edit' : 'Add') + ' Authentication Config'"
        (closed)="closeAuthPanel()"
        panelClass="w-full sm:min-w-[500px] lg:min-w-[600px] max-w-[700px] h-full flex flex-col overflow-hidden card-bg border-l border-[#EAEAEA] dark:border-line">
        <form [formGroup]="authForm" (ngSubmit)="saveAuthConfig()" class="flex flex-col flex-1 overflow-hidden h-full">
            <section class="flex flex-col gap-8 flex-1 overflow-y-auto p-10 text-[#141437] dark:text-white">

                <!-- Name -->
                <div class="space-y-3">
                    <label class="text-sm font-bold text-[#141437] dark:text-slate-200 block ml-1">Name <span
                            class="text-red-500">*</span></label>
                    <app-input formControlName="name" placeholder="Enter config name" variant="themeBase"></app-input>
                </div>

                <!-- Base URL -->
                <div class="space-y-3">
                    <label class="text-sm font-bold text-[#141437] dark:text-slate-200 block ml-1">Base URL <span
                            class="text-red-500">*</span></label>
                    <app-input formControlName="baseUrl" placeholder="https://api.example.com"
                        variant="themeBase"></app-input>
                </div>

                <!-- Auth Type -->
                <div class="space-y-3">
                    <label class="text-sm font-bold text-[#141437] dark:text-slate-200 block ml-1">Auth Type <span
                            class="text-red-500">*</span></label>
                    <app-dropdown [options]="authTypeOptions" formControlName="authType" variant="themeBase"
                        [fullWidth]="true" [searchable]="false" />
                </div>

                <!-- Token -->
                <div class="space-y-3">
                    <label class="text-sm font-bold text-[#141437] dark:text-slate-200 block ml-1">Token</label>
                    <app-input formControlName="token" placeholder="Enter token (optional)"
                        variant="themeBase"></app-input>
                </div>

            </section>

            <!-- Footer Action -->
            <div
                class="p-8 sticky bottom-0 bg-white dark:bg-surface-1 border-t border-[#EAEAEA] dark:border-line mt-auto">
                <div class="flex items-center justify-end gap-3">
                    <app-button variant="outline" (buttonClick)="closeAuthPanel()"
                        className="px-8 border-slate-200 text-slate-600 font-semibold h-11">Cancel</app-button>
                    <app-button type="submit" variant="primary"
                        className="px-12 bg-gradient-to-r from-[#AD46FF] to-[#8E2DE2] border-none hover:opacity-90 text-white font-bold h-11 shadow-[0px_6px_15px_-4px_rgba(173,70,255,0.4)]"
                        [disabled]="authForm.invalid">
                        {{ authIsEditMode() ? 'Update' : 'Save Config' }}
                    </app-button>
                </div>
            </div>
        </form>
    </app-slide-panel>

    <!-- Slide Panel: Agent Management -->
    <app-slide-panel [open]="agentPanelOpen()" [title]="(agentIsEditMode() ? 'Edit ' : 'Create / Setup ') + 'Agent'"
        (closed)="closeAgentPanel()"
        panelClass="w-full sm:min-w-[500px] lg:min-w-[600px] max-w-[700px] h-full flex flex-col overflow-hidden card-bg border-l border-[#EAEAEA] dark:border-line">
        <form [formGroup]="agentForm" (ngSubmit)="saveAgent()" class="flex flex-col flex-1 overflow-hidden h-full">
            <section class="flex flex-col gap-6 flex-1 overflow-y-auto p-10 text-[#141437] dark:text-white">

                <!-- Product -->
                <div class="space-y-2">
                    <label
                        class="text-xs font-semibold text-slate-500 dark:text-slate-400 block ml-1 uppercase tracking-wider">Product</label>
                    <app-dropdown [options]="agentProductDropdownOptions()" formControlName="product_id"
                        (selectionChange)="onAgentProductChange($event)" placeholder="Select product"
                        variant="themeBase" [fullWidth]="true" />
                </div>

                <!-- Feature -->
                <div class="space-y-2">
                    <label
                        class="text-xs font-semibold text-slate-500 dark:text-slate-400 block ml-1 uppercase tracking-wider">Feature</label>
                    <app-dropdown [options]="agentFeatureDropdownOptions()" formControlName="feature_id"
                        (selectionChange)="onAgentFeatureChange($event)" placeholder="Select feature"
                        variant="themeBase" [fullWidth]="true" />
                </div>

                <!-- Feature Page -->
                <div class="space-y-2">
                    <label
                        class="text-xs font-semibold text-slate-500 dark:text-slate-400 block ml-1 uppercase tracking-wider">Feature
                        Page</label>
                    <app-dropdown [options]="agentFeatureOptionDropdownOptions()" formControlName="feature_option_id"
                        placeholder="Select page" variant="themeBase" [fullWidth]="true" />
                </div>

                <!-- Select Pages -->
                <div class="space-y-2">
                    <div class="flex items-center gap-1.5 ml-1">
                        <label
                            class="text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Select
                            Pages</label>
                        <app-icon name="info" [size]="14" class="text-slate-400 cursor-help" />
                    </div>
                    <app-dropdown [options]="agentHeadlinePageDropdownOptions()" formControlName="page_ids"
                        (selectionChange)="onAgentPageChange($event)"
                        placeholder="Select page" variant="themeBase" [fullWidth]="true" [searchable]="true" />
                </div>

                <!-- Select APIs -->
                <div class="space-y-2">
                    <div class="flex items-center gap-1.5 ml-1">
                        <label
                            class="text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Select
                            APIs (Optional)</label>
                        <app-icon name="info" [size]="14" class="text-slate-400 cursor-help" />
                    </div>
                    <app-dropdown [options]="agentApiDropdownOptions()" formControlName="api_ids"
                        selectionMode="multiple" [multiSelectDisplayMode]="'label'" placeholder="No options to select"
                        variant="themeBase" [fullWidth]="true" [searchable]="true" />
                </div>

                <div class="pt-4 border-t border-slate-100 dark:border-slate-800/60 my-2">
                    <h3 class="text-lg font-bold text-[#141437] dark:text-white">Agent Setup</h3>
                </div>

                <!-- Agent Name -->
                <div class="space-y-2">
                    <label
                        class="text-xs font-semibold text-slate-500 dark:text-slate-400 block ml-1 uppercase tracking-wider">Agent
                        Name</label>
                    <app-input formControlName="name" placeholder="e.g. Revenue Insight Bot"
                        variant="themeBase"></app-input>
                </div>

                <!-- Knowledge Base Collection -->
                <div class="space-y-2">
                    <label
                        class="text-xs font-semibold text-slate-500 dark:text-slate-400 block ml-1 uppercase tracking-wider">Knowledge
                        Base Collection (Optional)</label>
                    <app-input formControlName="knowledge_base_collection" placeholder="Leave empty for auto detection"
                        variant="themeBase"></app-input>
                </div>


            </section>

            <!-- Footer Action -->
            <div
                class="p-8 sticky bottom-0 bg-white dark:bg-surface-1 border-t border-[#EAEAEA] dark:border-line mt-auto">
                <div class="flex items-center justify-start">
                    <app-button type="submit" variant="primary"
                        className="px-8 bg-[#FF5A5F] hover:bg-[#FF4449] border-none text-white font-bold h-11 rounded-lg shadow-sm transition-all"
                        [disabled]="agentForm.invalid">
                        {{ agentIsEditMode() ? 'Update Agent' : 'Create Agent' }}
                    </app-button>
                    <app-button variant="ghost" (buttonClick)="closeAgentPanel()"
                        className="ml-4 text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 transition-colors font-semibold">
                        Cancel
                    </app-button>
                </div>
            </div>
        </form>
    </app-slide-panel>

    <!-- Audit Logs -->
    <div class="mt-8 pb-10">
        <app-audit-log-panel [entityType]="auditEntityTypes" title="Headline Audit Trails">
        </app-audit-log-panel>
    </div>

</div>